import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Unlisted, `text-display-2` reads as a colour and is dropped beside `text-fg-1`; cn.test.ts fails on a missing key.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      animate: [
        'blink',
        'ring-out',
        'toast-in',
        'toast-out',
        'fade-in',
        'fade-up',
        'rise',
        'slide-up',
        'slide-in',
        'slide-out',
        'fade-nudge',
        'float',
        'sway',
        'march',
        'march-in',
        'march-out',
        'ripple',
        'shake',
        'pulse-ring',
        'letter-fall',
        'letter-drop',
        'hop',
        'tremble',
        'throb',
        'orbit',
        'sheen',
        'trace',
        'tap',
        'pop',
        'pop-out',
        'shrink-away',
        'fold',
        'unfold',
        'drop-in',
        'fly-off',
        'glide-into',
        'bounce-in',
        'spring-pop',
        'spring-in',
        'sparkle',
        'toss',
        'shimmer',
        'fill',
        'flicker',
        'drift',
        'glint',
        'unclip',
        'unclip-briefly',
        'demo-tap',
        'demo-press',
        'demo-show',
        'demo-hide',
        'demo-rise',
      ],
      container: ['page'],
      'drop-shadow': ['grail'],
      ease: ['in-out-slow', 'magnet', 'out-soft', 'out-strong', 'spring', 'spring-soft'],
      radius: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', 'sheet'],
      shadow: ['grail-sm', 'grail'],
      spacing: [
        'gutter',
        'header',
        'header-slim',
        'rail',
        'size-chip',
        'panel',
        'below-header',
        'page-inset',
        'page-inset-railed',
        'panel-room',
        'panel-edge',
        'title-display',
        'title-body',
      ],
      text: [
        '2xs',
        '11',
        '13',
        '15',
        '22',
        'display-hero',
        'display-1',
        'display-2',
        'display-3',
        'display-4',
        'display-5',
        'lede',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
